import React, { useState } from 'react';
import Button from '../../components/Button';
import AccountContentContainer from '../AccountContentContainer';
import LoginHandler from '../LoginHandler';
import IntegrationLoginButtons from './IntegrationLoginButtons';
import LoginPasswordFormView from './LoginPasswordFormView';
import styles from './LoginView.module.scss';

const { __slab } = window;

const LoginView = () => {
  const [isShowingGuestLogin, setIsShowingGuestLogin] = useState(false);
  const {
    email,
    effectiveHost,
    name,
    ssoPlatforms,
    settings: { authentication: authenticationSetting },
  } = window.__slab.PUBLIC_ORG;

  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const forceLoginPasswordForm =
    ssoPlatforms.length === 0 || isShowingGuestLogin;

  return (
    <AccountContentContainer
      title={`Log into ${name}`}
      subtitle={effectiveHost}
    >
      <LoginHandler>
        <IntegrationLoginButtons email={email} ssoPlatforms={ssoPlatforms} />
        {authenticationSetting !== 'SSO_ONLY' && ssoPlatforms.length > 0 && (
          <div className="auth-divider" />
        )}
        {(authenticationSetting === 'SSO_AND_PASSWORD' ||
          forceLoginPasswordForm) && (
          <>
            {ssoPlatforms.length > 0 && (
              <div className={styles.emailText}>
                Log in with your email and password
              </div>
            )}
            <LoginPasswordFormView />
          </>
        )}
        {authenticationSetting === 'SSO_AND_GUEST_PASSWORD' &&
          !forceLoginPasswordForm && (
            <Button
              block
              onClick={() => setIsShowingGuestLogin(true)}
              variant="secondary"
            >
              Log in with a guest account
              <div className="button-instruction">using email and password</div>
            </Button>
          )}
      </LoginHandler>
      <p className="terms">
        <span>By using Slab, you agree to the </span>
        <a href={`//${__slab.HOST}/terms`}>Terms of Service</a>
        <span> and </span>
        <a href={`//${__slab.HOST}/privacy`}>Privacy Policy</a>
      </p>
    </AccountContentContainer>
  );
};

export default LoginView;
